/**
 * LiveZoneRegistry - Maps content type strings to components.
 * Used by LiveZone to dynamically render the configured content types.
 */

// Registry object to hold component mappings
const registry = new Map();

export const LiveZoneRegistry = {
    /**
     * Register a content type component
     * @param {string} type - Content type name (e.g., 'scores', 'standings')
     * @param {React.Component} component - Component to render for this type
     */
    register(type, component) {
        registry.set(type, component);
    },

    /**
     * Get a component for a content type
     * @param {string} type - Content type name
     * @returns {React.Component|null} The registered component or null
     */
    get(type) {
        return registry.get(type) || null;
    },

    /**
     * Check if a content type is registered
     * @param {string} type - Content type name
     * @returns {boolean}
     */
    has(type) {
        return registry.has(type);
    },

    /**
     * Get all registered content types
     * @returns {string[]}
     */
    getTypes() {
        return Array.from(registry.keys());
    }
};

export default LiveZoneRegistry;
